import React, { useState } from 'react';
import Select from 'react-select';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


const AnalyticsModal = ({ isOpen, setIsOpen, statusOptions, handleSubmit, couponform, image, handleChange, setCouponForm, handleThumbnailChange, preImage, setData, user, video, AnalyticsOptions, loading }) => {

    const userOptions = user?.map(u => ({
        value: u.user_id,
        label: `${u.full_name}-${u.user_id}`,
        full: u
    }));

    // Filter videos for selected user
    const videoOptions = video
        ?.filter(v => v.user_id === couponform.user_id)
        .map(v => ({
            value: v.id,
            label: v.title,
            full: v
        }));
    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" >
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Analytics Details</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="image" className="oms-form-label">
                            User
                        </label>
                        <Select
                            options={userOptions}
                            placeholder="Search User..."
                            value={userOptions?.find(u => u.value === couponform.user_id) || null}
                            onChange={(selected) => {
                                setCouponForm(prev => ({
                                    ...prev,
                                    user_id: selected.value,
                                    user_name: selected.label,
                                    video_id: "",
                                    video: ""
                                }));
                            }}
                            required
                        />

                        {/* {
                            preImage ? <img style={{
                                width: "80px",
                                height: "50px"
                            }} src={`https://releasesworld.100billionoms.com/${preImage}`} alt="" /> : null
                        } */}

                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="title" className="oms-form-label">
                            Video
                        </label>
                        <Select
                            options={videoOptions}
                            placeholder={
                                couponform.user_id
                                    ? "Select Video"
                                    : "Select a user first"
                            }
                            isDisabled={!couponform.user_id}
                            value={videoOptions?.find(v => v.value === couponform.video_id) || null}
                            onChange={(selected) => {
                                setCouponForm(prev => ({
                                    ...prev,
                                    video_id: selected.value,
                                    video: selected.full
                                }));
                            }}
                            required
                        />

                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="title" className="oms-form-label">
                            Type
                        </label>
                        <Select
                            options={AnalyticsOptions}
                            placeholder="Select Type"
                            value={AnalyticsOptions.find(v => v.value === couponform.view_type) || null}
                            onChange={(selected) => {
                                setCouponForm(prev => ({
                                    ...prev,
                                    view_type: selected.value, // 👈 use `value`, not `view_type`
                                }));
                            }}
                            required
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="short_description" className="oms-form-label">
                            Views Count
                        </label>

                        <input
                            type="text"
                            id="views_count"
                            name="views_count"
                            value={couponform.views_count}
                            onChange={handleChange}
                            placeholder="Enter Views Count"
                            required
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="price" className="oms-form-label">
                            Subscribers Count
                        </label>
                        <input
                            type="number"
                            id="subscribers_count"
                            name='subscribers_count'
                            value={couponform.subscribers_count}
                            onWheel={(e) => { e.target.blur() }}
                            onChange={handleChange}
                            placeholder='Enter Subscribers count'
                            required
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="join_fee" className="oms-form-label">
                            Estimate Earning
                        </label>
                        <input
                            type="number"
                            id="estimate_earning"
                            name='estimate_earning'
                            value={couponform.estimate_earning}
                            onWheel={(e) => { e.target.blur() }}
                            onChange={handleChange}
                            placeholder='Enter Estimate Earning'
                            required
                        />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="join_fee" className="oms-form-label">
                            Watch Time (In minutes)
                        </label>
                        <input
                            type="number"
                            id="watch_time"
                            name='watch_time'
                            value={couponform.watch_time}
                            onWheel={(e) => { e.target.blur() }}
                            onChange={handleChange}
                            placeholder='Enter watch time (in minutes)'
                            required
                        />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        {
                            loading ? <button type="button">Submitting...</button> :
                                <button type="submit">Submit</button>
                        }

                    </div>
                </form>
            </div>
        </div>
    );
};

export default AnalyticsModal;
